import { useMutation, useQueryClient } from '@tanstack/react-query';

import { notify } from '@cast/design-system';
import { apiClient } from '@cast/infrastructure-api';
import { RebalancingSchedule } from '@cast/types';

import { getRebalancingSchedulesQueryKey } from 'hooks/queries/scheduled-rebalancing/useRebalancingSchedulesQuery';

type UseCreateScheduleMutationProps = {
  onSuccess?: (createdSchedule: RebalancingSchedule) => void;
  onError?: (error: unknown) => void;
};

export const useCreateScheduleMutation = ({
  onSuccess,
  onError = () => notify.error('Failed to create schedule'),
}: UseCreateScheduleMutationProps = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (config: RebalancingSchedule) => {
      return apiClient.scheduledRebalancing.createSchedule({
        schedule: config,
      });
    },
    onSuccess: ({ data }) => {
      queryClient.invalidateQueries({
        queryKey: getRebalancingSchedulesQueryKey(),
      });
      onSuccess?.(data);
    },
    onError,
  });
};
